export default __webpack_public_path__ + "static/media/linkedin.98ab6d9c.svg";